import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialForm, initialFormsState } from "./defaultState";
import { IFormsState } from "./forms.types";
import {
  FETCH_FORM_LIST_PROGRESS,
  FETCH_FORM_LIST_SUCCESS,
  FETCH_FORM_LIST_FAILED,
  FETCH_FORM_PROGRESS,
  FETCH_FORM_SUCCESS,
  FETCH_FORM_FAILED,
  CLEAR_FORM_STATE,
} from "./formsActions";

export const formsReducer = (
  state: IFormsState = initialFormsState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_FORM_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.error = null;
      });
    }

    case FETCH_FORM_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
        draftState.error = null;
      });
    }

    case FETCH_FORM_LIST_FAILED: {
      return produce(state, (draftState) => {
        const { errorMessage } = action.payload || {};
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage || "Failed to fetch forms";
      });
    }

    // Single Form Actions
    case FETCH_FORM_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.data = initialForm;
        draftState.error = null;
      });
    }

    case FETCH_FORM_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
        draftState.error = null;
      });
    }

    case FETCH_FORM_FAILED: {
      const { errorMessage } = action.payload || {};
      return produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = errorMessage || "Failed to fetch form";
      });
    }

    case CLEAR_FORM_STATE: {
      return produce(state, (draftState) => {
        draftState.data = initialForm;
      });
    }

    default: {
      return state;
    }
  }
};
